var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 text-brand-text text-sm h-full overflow-y-auto max-h-[calc(100vh-var(--vertical-padding)-45px-0px)]",staticStyle:{"max-height":"calc(100vh - var(--modal-header-height, 0px) - var(--modal-header-footer, 0px))"},attrs:{"data-component":"CsDrawerContent"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }